import { invokeWrapeeMethod, WrapeeNotSupportedError, WrapeeMethod } from '@globals/utilities/invokeWrapeeMethod';

type PermissionType = 'Permission.notification' | 'Permission.camera';
type AppSettingsType = 'AppSettingsType.notification' | 'AppSettingsType.settings';
type PermissionStatus = 'default' | 'granted' | 'denied' | 'permanentlyDenied' | 'notSupported';

export const getPermissionStatus = async (permission: PermissionType): Promise<PermissionStatus> => {
	try {
		const status = await invokeWrapeeMethod('getPermissionStatus', permission);

		return status as PermissionStatus;
	} catch (error) {
		if (!(error instanceof WrapeeNotSupportedError)) {
			console.error(error);
		}

		if (permission === 'Permission.notification' && typeof Notification === 'function') {
			const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
			return (isSafari || typeof Notification !== 'function') ? 'notSupported' : Notification.permission;
		}

		return 'notSupported';
	}
};

export const requestPermissionStatus = async (permission: PermissionType) => {
	try {
		return await invokeWrapeeMethod(WrapeeMethod.requestPermissionStatus, permission);
	} catch (error) {
		if (!(error instanceof WrapeeNotSupportedError)) {
			console.error(error);
		}

		return false;
	}
};

export const openAppSettings = async (permission: AppSettingsType) => {
	try {
		return await invokeWrapeeMethod(WrapeeMethod.openAppSettings, permission);
	} catch (error) {
		if (!(error instanceof WrapeeNotSupportedError)) {
			console.error(error);
		}

		return false;
	}
};
